@if (visible) {
<ion-button
  expand="block"
  [ngClass]="['main-btn', customClass]"
  [class.is-disabled]="disabled"
  [disabled]="disabled"
  (click)="handleClick()"
  [attr.type]="type"
>
  @if (loading) {
  <ion-spinner slot="start" name="crescent" class="mr-2 w-4 h-4" />
  } @else if (icon) {
  <ion-icon slot="start" [name]="icon" aria-hidden="true" />
  }
  {{ loading ? (loadingLabel | translate) : (label | translate) }}
</ion-button>
}
